module.exports = __webpack_public_path__ + "img/ios.0d6b5ab4.png";